"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/DownloadConsentDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _downloadConsent = require('shared/services/downloadConsent');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);





const FOCUSABLE = 'input:not([disabled]), button:not([disabled])'

/* Asks before a patient file is saved: Download stays off until the box is
 * ticked. Esc and Cancel cancel. Tab stays inside the dialog. */
const DownloadConsentDialog = ({ onAnswer }) => {
  const [understood, setUnderstood] = _react.useState.call(void 0, false)
  const bodyRef = _react.useRef(null)
  const cancel = _react.useCallback.call(void 0, () => onAnswer(false), [onAnswer])
  const confirm = _react.useCallback.call(void 0, () => { if (understood) onAnswer(true) }, [understood, onAnswer])
  const tick = _react.useCallback.call(void 0, (e) => setUnderstood(e.target.checked), [])

  _react.useEffect.call(void 0, () => {
    _optionalChain([bodyRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.querySelector, 'call', _3 => _3('input'), 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()])
  }, [])

  const trapTab = _react.useCallback.call(void 0, (e) => {
    if (e.key !== 'Tab' || !bodyRef.current) return
    const focusable = Array.from(bodyRef.current.querySelectorAll(FOCUSABLE))
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (!first || !last) return
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault()
      last.focus()
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault()
      first.focus()
    }
  }, [])

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, onClose: cancel, title: _downloadConsent.DOWNLOAD_CONSENT_TITLE, size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      , _react2.default.createElement('div', { ref: bodyRef, onKeyDown: trapTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        , _react2.default.createElement(_Modal.ModalDesc, { className: "download-consent--notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, _downloadConsent.DOWNLOAD_CONSENT_BODY)
        , _react2.default.createElement('label', { className: "download-consent--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
          , _react2.default.createElement('input', { type: "checkbox", checked: understood, onChange: tick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}} )
          , ' ', _downloadConsent.DOWNLOAD_CONSENT_CHECKBOX
        )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: _downloadConsent.DOWNLOAD_CONSENT_CANCEL,
          onSecondaryBtnClick: cancel,
          primaryBtnLabel: _downloadConsent.DOWNLOAD_CONSENT_CONFIRM,
          onPrimaryBtnClick: confirm,
          isPrimaryEnabled: understood, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        )
      )
    )
  )
}

exports. default = DownloadConsentDialog
